import { createContext, useContext } from "react";

export type ToastTone = "success" | "error" | "info";

export interface ToastApi {
  show: (message: string, tone?: ToastTone) => void;
}

export const ToastContext = createContext<ToastApi>({
  show: () => undefined,
});

export function useToast(): ToastApi {
  return useContext(ToastContext);
}
